
import {define} from "observable:runtime";
import asset1 from "../style.css?url";

const assets = new Map([
  ["../style.css", asset1]
]);

define(
  {
    root: document.getElementById(`cell-2`),
    expanded: [],
    variables: []
  },
  {
    id: 2,
    body: async (html,display) => {
const {createUI, installHashImportBanner, installThemeToggle} = await import("../lib/helpers.js").then((module) => {
  if (!("createUI" in module)) throw new SyntaxError(`export 'createUI' not found`);
  if (!("installHashImportBanner" in module)) throw new SyntaxError(`export 'installHashImportBanner' not found`);
  if (!("installThemeToggle" in module)) throw new SyntaxError(`export 'installThemeToggle' not found`);
  return module;
});
installThemeToggle({ html, display });
installHashImportBanner({ html, display });
const { codeEditor, canvasOutput, canvasTest, canvasTestReport } = createUI({ html });
return {createUI,installHashImportBanner,installThemeToggle,codeEditor,canvasOutput,canvasTest,canvasTestReport};
},
    inputs: ["html","display"],
    outputs: ["createUI","installHashImportBanner","installThemeToggle","codeEditor","canvasOutput","canvasTest","canvasTestReport"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-4`),
    expanded: [],
    variables: []
  },
  {
    id: 4,
    body: (view,codeEditor) => {
const code_basic = view(codeEditor("canvas:text-basic", {
  value: `ctx.strokeStyle = "blue"
ctx.lineWidth = 1
ctx.strokeText("Stroke Canvas!", 50, 100)

ctx.fillStyle = "black"
ctx.fillText("Fill Canvas!", 50, 200)`
}));
return {code_basic};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_basic"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-5`),
    expanded: [],
    variables: []
  },
  {
    id: 5,
    body: (display,canvasOutput,code_basic) => {
display(canvasOutput(code_basic, { width: 400, height: 260 }));
},
    inputs: ["display","canvasOutput","code_basic"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-7`),
    expanded: [],
    variables: []
  },
  {
    id: 7,
    body: (view,codeEditor) => {
const code_baseline = view(codeEditor("canvas:text-baseline", {
  value: `ctx.font = "24px Arial"

// rote Hilfslinie auf der Baseline (y = 100)
ctx.strokeStyle = "red"
ctx.beginPath()
ctx.moveTo(0, 100)
ctx.lineTo(400, 100)
ctx.stroke()

ctx.fillStyle = "black"
ctx.fillText("The quick brown fox", 25, 100)`
}));
return {code_baseline};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_baseline"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-8`),
    expanded: [],
    variables: []
  },
  {
    id: 8,
    body: (display,canvasOutput,code_baseline) => {
display(canvasOutput(code_baseline, { width: 400, height: 200 }));
},
    inputs: ["display","canvasOutput","code_baseline"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-10`),
    expanded: [],
    variables: []
  },
  {
    id: 10,
    body: (view,codeEditor) => {
const code_font = view(codeEditor("canvas:text-font", {
  value: `ctx.fillStyle = "black"

ctx.font = "30px Arial"
ctx.fillText("Normaler Text", 30, 50)

ctx.font = "bold 30px Arial"
ctx.fillText("Fetter Text", 30, 110)

ctx.font = "italic 30px Arial"
ctx.fillText("Kursiver Text", 30, 170)

ctx.font = "bold italic 40px Courier"
ctx.fillText("Groß & Courier", 30, 240)`
}));
return {code_font};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_font"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-11`),
    expanded: [],
    variables: []
  },
  {
    id: 11,
    body: (display,canvasOutput,code_font) => {
display(canvasOutput(code_font, { width: 460, height: 280 }));
},
    inputs: ["display","canvasOutput","code_font"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-13`),
    expanded: [],
    variables: []
  },
  {
    id: 13,
    body: (view,codeEditor) => {
const code_align = view(codeEditor("canvas:text-align", {
  value: `// Hilfslinie bei x = 150
ctx.strokeStyle = "red"
ctx.beginPath()
ctx.moveTo(150, 0)
ctx.lineTo(150, 300)
ctx.stroke()

ctx.fillStyle = "black"
ctx.font = "36px Arial"

ctx.textAlign = "left"
ctx.fillText("left", 150, 70)

ctx.textAlign = "center"
ctx.fillText("center", 150, 150)

ctx.textAlign = "right"
ctx.fillText("right", 150, 230)`
}));
return {code_align};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_align"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-14`),
    expanded: [],
    variables: []
  },
  {
    id: 14,
    body: (display,canvasOutput,code_align) => {
display(canvasOutput(code_align, { width: 320, height: 300 }));
},
    inputs: ["display","canvasOutput","code_align"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-16`),
    expanded: [],
    variables: []
  },
  {
    id: 16,
    body: (view,codeEditor) => {
const code_baseline2 = view(codeEditor("canvas:text-baseline2", {
  value: `// Hilfslinie bei y = 100
ctx.strokeStyle = "red"
ctx.beginPath()
ctx.moveTo(0, 100)
ctx.lineTo(400, 100)
ctx.stroke()

ctx.fillStyle = "black"
ctx.font = "28px Arial"

ctx.textBaseline = "alphabetic"
ctx.fillText("alpha", 10, 100)

ctx.textBaseline = "top"
ctx.fillText("top", 150, 100)

ctx.textBaseline = "middle"
ctx.fillText("middle", 250, 100)`
}));
return {code_baseline2};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_baseline2"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-17`),
    expanded: [],
    variables: []
  },
  {
    id: 17,
    body: (display,canvasOutput,code_baseline2) => {
display(canvasOutput(code_baseline2, { width: 400, height: 200 }));
},
    inputs: ["display","canvasOutput","code_baseline2"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-19`),
    expanded: [],
    variables: []
  },
  {
    id: 19,
    body: (view,codeEditor) => {
const code_color = view(codeEditor("canvas:text-color", {
  value: `ctx.font = "40px Arial"

ctx.fillStyle = "blue"
ctx.fillText("Blau", 50, 60)

ctx.strokeStyle = "red"
ctx.lineWidth = 2
ctx.strokeText("Rot-Umriss", 50, 120)

ctx.fillStyle = "yellow"
ctx.strokeStyle = "black"
ctx.lineWidth = 3
ctx.fillText("Gelb mit Rand", 50, 190)
ctx.strokeText("Gelb mit Rand", 50, 190)`
}));
return {code_color};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_color"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-20`),
    expanded: [],
    variables: []
  },
  {
    id: 20,
    body: (display,canvasOutput,code_color) => {
display(canvasOutput(code_color, { width: 400, height: 230 }));
},
    inputs: ["display","canvasOutput","code_color"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-22`),
    expanded: [],
    variables: []
  },
  {
    id: 22,
    body: (view,codeEditor) => {
const code_ex1 = view(codeEditor("canvas:text-ex1", {
  value: `// Quadrat + Beschriftungen:
`
}));
return {code_ex1};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_ex1"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-23`),
    expanded: [],
    variables: []
  },
  {
    id: 23,
    body: (display,canvasOutput,code_ex1) => {
display(canvasOutput(code_ex1, { width: 400, height: 320 }));
},
    inputs: ["display","canvasOutput","code_ex1"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-24`),
    expanded: [],
    variables: []
  },
  {
    id: 24,
    body: (display,canvasTestReport,canvasTest,code_ex1) => {
const texts1 = (base) => [...base.callsTo("fillText"), ...base.callsTo("strokeText")]
  .map(c => String(c.args[0] ?? ""));
display(canvasTestReport(canvasTest(code_ex1, {
  width: 400, height: 320,
  checks: [
    { name: "„Quadrat\" steht im Bild", run: ({ base }) => texts1(base).some(t => /quadrat/i.test(t)) },
    { name: "Wort + vier Ecken beschriftet", run: ({ base }) => {
        const n = texts1(base).length;
        return { passed: n >= 5, detail: `${n} Beschriftungen` };
    } },
    { name: "Horizontale Ausrichtung (`textAlign`)", run: ({ base }) =>
        base.setsOf("textAlign").map(String).includes("center") },
    { name: "Vertikale Ausrichtung (`textBaseline`)", run: ({ base }) =>
        base.setsOf("textBaseline").length > 0 },
    { name: "Quadrat gezeichnet", run: ({ base }) =>
        base.callsTo("strokeRect").length >= 1 || base.callsTo("fillRect").length >= 2 }
  ]
}), "Übung 1"));
return {texts1};
},
    inputs: ["display","canvasTestReport","canvasTest","code_ex1"],
    outputs: ["texts1"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-26`),
    expanded: [],
    variables: []
  },
  {
    id: 26,
    body: (view,codeEditor) => {
const code_ex2 = view(codeEditor("canvas:text-ex2", {
  value: `const größe = 40
const rand = 20

// 1. Schachbrett zeichnen (mit Versatz um 'rand')
// 2. Buchstaben A-H unter den Spalten, Zahlen 1-8 links der Reihen
`
}));
return {code_ex2};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_ex2"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-27`),
    expanded: [],
    variables: []
  },
  {
    id: 27,
    body: (display,canvasOutput,code_ex2) => {
display(canvasOutput(code_ex2, { width: 380, height: 380 }));
},
    inputs: ["display","canvasOutput","code_ex2"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-28`),
    expanded: [],
    variables: []
  },
  {
    id: 28,
    body: (display,canvasTestReport,canvasTest,code_ex2) => {
const texts2 = (base) => [...base.callsTo("fillText"), ...base.callsTo("strokeText")]
  .map(c => String(c.args[0] ?? "").trim());
display(canvasTestReport(canvasTest(code_ex2, {
  width: 380, height: 380,
  checks: [
    { name: "Schachbrett gezeichnet", run: ({ base }) => {
        const n = base.callsTo("fillRect").length;
        return { passed: n >= 16, detail: `${n} Felder` };
    } },
    { name: "Buchstaben für die Spalten (A–H)", run: ({ base }) => {
        const set = new Set(texts2(base).filter(t => /^[A-H]$/.test(t)));
        return { passed: set.size >= 4, detail: `${set.size} verschiedene Buchstaben` };
    } },
    { name: "Zahlen für die Reihen (1–8)", run: ({ base }) => {
        const set = new Set(texts2(base).filter(t => /^[1-8]$/.test(t)));
        return { passed: set.size >= 4, detail: `${set.size} verschiedene Zahlen` };
    } }
  ]
}), "Übung 2"));
return {texts2};
},
    inputs: ["display","canvasTestReport","canvasTest","code_ex2"],
    outputs: ["texts2"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
